import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowRight } from "lucide-react";

const NotFound = () => (
  <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="not-found-page">
    <div className="text-center max-w-lg">
      <div className="font-orbitron font-black text-7xl text-spike-blue-light tracking-tighter">404</div>
      <h1 className="mt-4 font-orbitron font-black uppercase text-2xl text-spike-text tracking-tight">
        Off the pitch.
      </h1>
      <p className="mt-3 font-exo text-spike-text-muted">
        The page you're looking for doesn't exist — let's get you back to the lanes.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-8 inline-flex items-center gap-3 bg-spike-blue hover:bg-spike-blue-hover text-white font-orbitron font-bold uppercase tracking-[0.22em] text-xs px-6 py-4 transition-colors"
      >
        <Home className="w-4 h-4" /> Back home <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    </div>
  </div>
);

export default NotFound;
